export default "__VITE_ASSET__9bafccc9__"